import Head from "next/head";

type Props = {
  meta: {
    title: string;
  };
  content: string;
};

export function MarkdownPage({ meta, content }: Props) {
  return (
    <div className="max-w-2xl pt-10 lg:pt-20  px-4 mx-auto prose">
      <Head>
        <title>{meta.title}</title>
      </Head>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
}
